<template>
    <div>
        <el-row>
            <el-col :lg="3">
             
                    <el-radio-group v-model="itemType" @change="changeItem">
                        <el-radio :label="1">單品</el-radio>
                        <el-radio :label="2">組合</el-radio>
                        <el-radio :label="3">任搭</el-radio>
                    </el-radio-group>
            
            </el-col>
            
        </el-row>
        
        <addSingle @back="back" :itemType="itemType" v-if="isShowSingle" />
        <addBundle :itemType="itemType" v-if="isShowBundle" @back="back" />
        <addAny :itemType="itemType" v-if="isShowAny" @back="back" />
        
    </div>
</template>

<script>
import addSingle from './addSingle'
import addBundle from './addBundle'
import addAny from './addAny'
    export default {
        name: 'Add',
        components: {
            addSingle,
            addBundle,
            addAny,
         
        },
        data() {
            return {
                isShowSingle: true,
                isShowBundle: false,
                isShowAny: false,
                itemType: 1,
                
            singleForm:{
                on_sale: true,
                on_sale_start: '',
                on_sale_end: '',
                brand_id: 1,
                class_key: '',
                id: '',
                name: '',
                price: 0,
                memberlevel_1: 1,
                memberlevel_2: 2,
                memberlevel_3: 3,
                memberdiscount_1: 0,
                memberdiscount_2: 0,
                personal_performance: 0,
                performance_ratio: '',
                spec: '',
                images:[]
            },
            bundleForm:{
                on_sale: true,
                on_sale_start: '',
                on_sale_end: '',
                brand_id: 1,
                class_key: '',
                id: '',
                name: '',
                price: 0,
                images: [],
                items: [],
               
            },
            anyForm:{
                     on_sale: true,
                on_sale_start: '',
                on_sale_end: '',
                brand_id: 1,
                class_key: '',
                id: '',
                name: '',
                price: 0,
                images: [],
                items: [],
                choose: 0,
            }
            }
        },
      
        methods: {
            changeItem: function(){
                if (this.itemType == 1) {
                    this.single()
                } else if (this.itemType == 2) {
                    this.bundle()
                } else if(this.itemType == 3) {
                    this.any()
                }
           
            
            },
            single: function(){
                  this.isShowSingle = true
                    this.isShowBundle = false
                    this.isShowAny = false    
            },
            bundle: function(){
                this.isShowAny = false
                    this.isShowSingle = false
                    this.isShowBundle = true
            },
            any: function(){
                    this.isShowBundle = false
                    this.isShowSingle = false
                    this.isShowAny = true
            },
            back: function() {
                this.$emit('back')
            }
            
        },
    }
</script>

<style lang="scss" scoped>
    .el-radio-group {
        margin-bottom: 30px;
    }
</style>